<ul>
  <li *ngIf="!is_premium || viewingKilnlinkFreeKilns && !is_logged_in_as && !is_on_admin_pages && !accountExpired" (click)="addKilnClick()">
    <ion-icon name="add" class="icon"></ion-icon>
    <p>{{ 'PREMIUM_MENU.ADD_CONTROLLER' | translate }}</p>
  </li>
  <li *ngIf="!is_on_admin_pages && !readonlyUser" (click)="goToAccountAdmin()">
    <ion-icon name="settings-outline"></ion-icon>
    <p>{{ 'PREMIUM_MENU.ACCOUNT_ADMIN' | translate }}</p>
  </li>
  <li *ngIf="hasElevatedPermissions && !is_on_admin_pages"
    class="elevated-permissions"
    (click)="showModal('login-as')">
    <ion-icon name="people"></ion-icon>
    <p>{{ 'PREMIUM_MENU.LOGIN_AS' | translate }}</p>
  </li>
  <li *ngIf="is_logged_in_as && hasElevatedPermissions && !is_on_admin_pages"
    class="elevated-permissions"
    (click)="exitLoginAs()">
    <ion-icon name="people"></ion-icon>
    <p>{{ 'PREMIUM_MENU.EXIT_LOGIN_AS' | translate }}</p>
  </li>
  <li *ngIf="!is_logged_in_as && hasElevatedPermissions && !is_on_admin_pages"
    class="elevated-permissions"
    (click)="showModal('admin-account-list', true)">
    <ion-icon name="business"></ion-icon>
    <p>{{ 'PREMIUM_MENU.ADMIN_PORTAL' | translate }}</p>
  </li>
  <li *ngIf="!is_logged_in_as && is_on_admin_pages" class="elevated-permissions"
    (click)="showModal('kiln-list', true)">
    <ion-icon name="list"></ion-icon>
    <p>{{ 'PREMIUM_MENU.EXIT_ADMIN_PORTAL' | translate }}</p>
  </li>
  <!-- <li *ngIf="is_premium" (click)="showModal('account-invites')">
    <ion-icon name="mail-unread"></ion-icon>
    <p>Account Invites</p>
  </li> -->
  <li *ngIf="!is_logged_in_as && is_premium && hasElevatedPermissions" (click)="registerControllers()" class="elevated-permissions">
    <ion-icon name="cloud-upload" class="icon"></ion-icon>
    <p>{{ 'PREMIUM_MENU.REGISTER_KMT_CONTROLLER' | translate }}</p>
  </li>
  <li *ngIf="!is_logged_in_as && hasElevatedPermissions" (click)="goToKilnSearch()" class="elevated-permissions">
    <ion-icon name="search" class="icon"></ion-icon>
    <p>{{ 'PREMIUM_MENU.SEARCH_KMT_CONTROLLERS' | translate }}</p>
  </li>
  <li *ngIf="!is_logged_in_as && hasElevatedPermissions && !smallScreen" (click)="togglePremium()" class="elevated-permissions">
    <ion-icon *ngIf="!is_premium" class="icon" name="flask"></ion-icon>
    <ion-icon *ngIf="is_premium" class="icon" name="phone-portrait"></ion-icon>
    <p>{{ (is_premium ? 'PREMIUM_MENU.TOGGLE_TO_KILNLINK_FREE' : 'PREMIUM_MENU.TOGGLE_TO_KILNLINK_PREMIUM') | translate }}</p>
  </li>
  <!-- <li *ngIf="!is_logged_in_as && is_premium && hasElevatedPermissions" class="elevated-permissions">
    <ion-icon name="key"></ion-icon>
    <p><a href="http://skutt-kilnlink-admin.s3-website-us-west-2.amazonaws.com/home">KilnLink Free Admin</a></p>
  </li> -->
  <li (click)="logOut()">
    <ion-icon name="log-out"></ion-icon>
    <p>{{ 'PREMIUM_MENU.LOGOUT' | translate }}</p>
  </li>
</ul>
